import { gql } from '@apollo/client';

export const UPDATE_INCIDENT_DETAIL_ALL_FIELDS = gql`
  mutation updateIncidentDetail($input: UpdateIncidentDetailInput!) {
    updateIncidentDetail(input: $input) {
      clientMutationId
      errors
      incidentDetail {
        alcohol
        audioRecordings
        clothingEvidence
        crimeSceneProcessed
        crisisServiceInvolved
        dcfNotified
        diagrams
        genericAttachments {
          attachmentType {
            id
            name
            oriId
            position
          }
          incident {
            id
            ori {
              id
            }
          }
          confidential
          dataUrl
          dataUrlWrapper
          description
          id
        }
        id
        incidentNarratives {
          confidential
          employee {
            id
            deptAttribute {
              id
              badge
              ori {
                id
                oriName
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
          id
          incidentNarrativeType {
            id
            name
            oriId
            position
          }
          narrative
          timestamp
        }
        incidentOffenses {
          assaultTypes {
            id
            name
            oriId
            position
          }
          campusCode {
            id
            name
            oriId
            position
          }
          committedType {
            id
            name
            oriId
            position
          }
          counts
          criminalActivityTypes {
            id
            name
            oriId
            position
          }
          entryPointType {
            id
            name
            oriId
            position
          }
          exitPointType {
            id
            name
            oriId
            position
          }
          forceNoForceType {
            id
            name
            oriId
            position
          }
          id
          justifiableHomicideType {
            id
            name
            oriId
            position
          }
          locationType {
            id
            name
            oriId
            position
          }
          nibrsViolationType {
            id
            name
            oriId
            position
          }
          numberOfPremisesEntered
          offenseGangAffiliateds {
            id
            name
            oriId
            position
          }
          offenseIbrDesignation {
            id
            name
            oriId
            position
          }
          offenseViolationPrototype {
            id
            maxPenalty
            minPenalty
            fullName
            name
            offenseCategory {
              id
              name
              oriId
              position
            }
            offenseSubCategory {
              id
              name
              oriId
              position
            }
            oriId
            points
            waiver
            yoe
          }
          offenseWeaponTypes {
            id
            name
            oriId
            position
          }
          significantEvent {
            id
            name
            oriId
            position
          }
          suspectVictimAffiliations {
          sealed
            biasType {
              id
              name
              oriId
              position
            }
            ibrSuspectVictimRelationshipType {
              id
              name
              oriId
              position
            }
            id
            leokaNarrative
            suspect {
              id
              personalAttribute {
                id
                firstName
                lastName
                dob
              }
            }
            svaOri {
              abbreviation
              agencyType
              id
              oriName
            }
            victim {
              id
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            victimLeoAssignment {
              id
              name
              oriId
              position
            }
            victimLeoState {
              id
              name
              oriId
              position
            }
          }
        }
        investigatingOfficer {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              oriName
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        k9
        lprUsed
        mediaSummary
        medicalRelease
        miranda
        nineOneOneCall
        occurredFrom
        occurredTo
        otherPhysicalEvidence
        photosTaken
        physicalEvidenceText
        printsLifted
        searchType {
          id
          name
          oriId
          position
        }
        secondaryCallType {
          id
          name
          oriId
          position
        }
        siuContacted
        specialVictimsUnit {
          id
          name
          oriId
          position
        }
        swabbings
        troFroExists
        videoRecordings
      }
    }
  }
`


